const post = {
  slug: 'website-relaunch-leitfaden',
  title: 'Website-Relaunch: Der Fahrplan für einen reibungslosen Wechsel',
  excerpt:
    'Ein Relaunch kann Rankings und Umsätze kosten, wenn er unstrukturiert läuft. So planen Sie den Wechsel auf eine neue Website ohne unangenehme Überraschungen.',
  category: 'Web-Entwicklung',
  art: 'web',
  tags: ['Web-Entwicklung', 'Relaunch', 'SEO', 'Projektplanung'],
  author: 'Nexite Team',
  date: '2026-06-15',
  readingTime: 5,
  intro:
    'Ein Website-Relaunch ist eine der risikoreichsten Phasen im digitalen Lebenszyklus eines Unternehmens. Ohne klaren Plan drohen Ranking-Verluste, defekte Links und frustrierte Nutzer. Mit der richtigen Vorbereitung wird aus dem Risiko jedoch eine Chance – für bessere Performance, moderneres Design und mehr Konversionen.',
  sections: [
    {
      heading: 'Warum die meisten Relaunches straucheln',
      paragraphs: [
        'Viele Relaunch-Projekte konzentrieren sich ausschließlich auf das neue Design und vergessen dabei die technische Kontinuität. URL-Strukturen ändern sich, Weiterleitungen fehlen, und Suchmaschinen verlieren den Kontext zu bereits gut rankenden Seiten. Das Ergebnis: sichtbare Traffic-Einbrüche in den Wochen nach dem Go-Live – oft vermeidbar mit sorgfältiger Vorbereitung.',
      ],
    },
    {
      heading: 'Die Phasen eines sicheren Relaunches',
      paragraphs: [
        'Ein strukturierter Relaunch lässt sich in klar abgegrenzte Phasen unterteilen, die jeweils eigene Prüfpunkte haben:',
      ],
      bullets: [
        'Audit der bestehenden Seite: Rankings, Backlinks, Traffic-Quellen und technische Altlasten erfassen',
        'URL-Mapping: jede alte URL bekommt ein definiertes 301-Redirect-Ziel auf der neuen Seite',
        'Staging-Umgebung: die neue Website wird vollständig getestet, bevor sie live geht',
        'Go-Live mit Monitoring: Rankings, Ladezeiten und Fehlerseiten werden in den ersten Wochen engmaschig beobachtet',
      ],
    },
    {
      heading: 'SEO-Fallstricke vermeiden',
      paragraphs: [
        'Suchmaschinen bewerten eine relaunchte Seite neu – wie stark diese Neubewertung ausfällt, hängt maßgeblich von der technischen Umsetzung ab.',
      ],
      bullets: [
        'Lückenlose 301-Weiterleitungen statt einer pauschalen Weiterleitung auf die Startseite',
        'Eine aktuelle XML-Sitemap, die direkt bei Google Search Console eingereicht wird',
        'Strukturierte Daten und Meta-Angaben werden 1:1 in die neue Seite übernommen',
        'Interne Verlinkung wird überprüft, damit keine Linkstruktur ins Leere führt',
      ],
    },
    {
      heading: 'Performance als Teil des Relaunches',
      paragraphs: [
        'Ein Relaunch ist der ideale Zeitpunkt, um Ladezeiten und Core Web Vitals zu verbessern. Optimierte Bildformate, sauberer Code und ein durchdachtes Caching-Konzept wirken sich direkt auf Rankings und Nutzererfahrung aus – und sind deutlich einfacher umzusetzen, wenn sie von Anfang an mitgeplant werden, statt sie nachträglich in eine bestehende Seite zu pressen.',
      ],
    },
    {
      heading: 'Fazit',
      paragraphs: [
        'Ein Relaunch muss kein Risiko sein. Mit einem strukturierten URL-Mapping, sauberen Weiterleitungen und einem Blick auf Performance von Anfang an wird der Wechsel zur Chance, Ihre digitale Präsenz technisch und gestalterisch auf ein neues Level zu heben – ohne die mühsam aufgebaute Sichtbarkeit zu verlieren.',
      ],
    },
  ],
  cta: 'Sie planen einen Relaunch? Wir erstellen ein lückenloses URL-Mapping, testen jede Weiterleitung und begleiten den Go-Live – damit Ihre Rankings und Ihr Traffic geschützt bleiben.',
  related: ['online-marketing', 'ai-in-crm'],
};

export default post;
